module.exports = __webpack_public_path__ + "static/media/4-10.3cdab5a5.png";